import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

/**
 * Reorder a paid cancelled catering order
 * @param {string|number} orderId - Order ID
 * @param {Object} payload - Reorder payload with order details
 * @returns {Promise} API response
 */
export const reorderCateringPaidCancelOrder = async (orderId, payload) => {
  try {
    console.log('🔄 Reordering paid cancelled catering order:', {
      orderId,
      payload
    });

    const endpoint = API_ENDPOINTS.REORDER_CATERING_PAID_CANCEL_ORDER.replace(':orderId', orderId);
    const response = await apiClient.post(endpoint, payload);

    console.log('✅ Reorder paid cancelled order response:', response);
    return response;
  } catch (error) {
    console.error('❌ Error reordering paid cancelled order:', error);
    throw error;
  }
};

